import { render, staticRenderFns } from "./DataTypesList.vue?vue&type=template&id=3218da1e"
import script from "./DataTypesList.vue?vue&type=script&lang=js"
export * from "./DataTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports